var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcMenu = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, "ic_menu") : title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "path-1",
  x: 0,
  y: 0,
  width: 24,
  height: 24
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "ic_menu",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "close"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle-8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22,5.5 L22,6.5 L2,6.5 L2,5.5 L22,5.5 Z M22,11.5 L22,12.5 L2,12.5 L2,11.5 L22,11.5 Z M22,17.5 L22,18.5 L2,18.5 L2,17.5 L22,17.5 Z",
  id: "Combined-Shape",
  fill: "#ffffff",
  mask: "url(#mask-2)"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcMenu);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "matrices-static/media/ic_menu.9e73df724ddfa67d27a40ecadfb910ba.svg";